var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecksOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7071 8.29289C19.0676 8.65338 19.0953 9.22061 18.7903 9.6129L18.7071 9.70711L8.70711 19.7071C8.34662 20.0676 7.77939 20.0953 7.3871 19.7903L7.29289 19.7071L3.29289 15.7071C2.90237 15.3166 2.90237 14.6834 3.29289 14.2929C3.65338 13.9324 4.22061 13.9047 4.6129 14.2097L4.70711 14.2929L8 17.585L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289ZM24.7071 8.29289C25.0676 8.65338 25.0953 9.22061 24.7903 9.6129L24.7071 9.70711L14.7071 19.7071C14.3166 20.0976 13.6834 20.0976 13.2929 19.7071C12.9324 19.3466 12.9047 18.7794 13.2097 18.3871L13.2929 18.2929L23.2929 8.29289C23.6834 7.90237 24.3166 7.90237 24.7071 8.29289Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecksOutline);
export default __webpack_public_path__ + "static/media/checks_outline.67aaba60823cd78186ce589619f30099.svg";
export { ForwardRef as ReactComponent };